import { MILLISECONDS_PER_SECOND } from 'constants/date';

export const DEFAULT_MAX_LOADING_TIME = 60 * MILLISECONDS_PER_SECOND;
